import { ROUTE_NAMES, ERROR_CLASS, SCROLL_TO_OFFSET } from './../../constants/complaint-constants';
import { mapActions, mapGetters, mapState } from 'vuex';
import foreignPhoneInput from '../../../../common/components/foreign-phone-input/foreign-phone-input.vue';
import datePicker from '../../../../common/components/date-picker/date-picker';
import bankAccountNumberInputSimple from '../../../../common/components/bank-account-number-input-simple/bank-account-number-input-simple.vue';
import phoneInput from '../../../../common/components/phone-input/phone-input.vue';
import accountNumberLength from '../../../../common/js/validators/account-number-length';
import VueSettlementSelector from '@ui-common/vue-settlement-selector';
import { required, maxLength } from 'vuelidate/lib/validators';
import email from '../../../../common/js/validators/email';
import date from '../../../../common/js/validators/date';
import dateLessThanOrEqual from '../../../../common/js/validators/date-less-than-or-equal';
import dateGreaterThanOrEqual from '../../../../common/js/validators/date-greater-than-or-equal';
import pattern from '../../../../common/js/validators/pattern';
import accountNumberLength18Or24Digit from '../../../../common/js/validators/account-number-length-18-o-24-digit';
import {
	BACKEND_DATE_FORMAT,
	NAME_REGEXP,
	ZIP_CODE_REGEXP,
	FOREIGN_ZIP_CODE_REGEXP,
	FOREIGN_PHONE_REGEX,
	LAST_FOUR_DIGITS_REGEXP,
	ALL_PHONE_REGEXP
} from '../../../../common/js/constants/constants';
import moment from 'moment';
import { minLength } from 'vuelidate/lib/validators/index';

import VueErrorMessage from '@ui-common/vue-error-message';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueInput from '@ui-common/vue-input';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import { jumpToFirstError } from '../../../../common/js/find-first-error-component/find-first-error-component';
import messages from './complaints-personal-form-lang.json';

const MIN_DATE = '1900-01-01';
const DEFAULT_COUNTRY = {
	hu: 'Magyarország',
	en: 'Hungary'
};

export default {
	mixins: [jumpToFirstError],
	i18n: { messages },
	data() {
		return {
			model: {
				name: null,
				birthDate: null,
				email: null,
				accountNumber: null,
				lastDigitsOfCard: null,
				isForeigner: false,
				phoneNumber: null,
				postalCode: null,
				settlement: null,
				address: null,
				country: DEFAULT_COUNTRY[this.$i18n.locale]
			},
			settlement: {}
		};
	},
	methods: {
		...mapActions('complaints', ['goToNextStep', 'getSettlements', 'storePersonalModel']),
		nextStep() {
			this.$router.push(ROUTE_NAMES.SUMMARY);
		},
		isFormInvalid() {
			this.$v.model.$touch();
			return this.$v.$invalid;
		},
		submit() {
			return this.storePersonalModel({ model: JSON.parse(JSON.stringify(this.model)), lang: this.$i18n.locale });
		},
		scrollToErrorMessage() {
			this.$nextTick(() => {
				let elem = this.$el.querySelector(ERROR_CLASS);
				if (elem) {
					this.$scrollTo(elem, { offset: SCROLL_TO_OFFSET });
				}
			});
		},
		clearModelOnCheckbox() {
			this.model.phoneNumber = null;
			this.model.postalCode = null;
			this.model.settlement = null;
			this.model.address = null;
			this.model.country = this.model.isForeigner ? null : DEFAULT_COUNTRY;
			this.settlement = null;
			this.$v.model.phoneNumber.$reset();
			this.$v.model.postalCode.$reset();
			this.$v.model.address.$reset();
			this.$v.model.settlement.$reset();
			this.$v.model.country.$reset();
		},
		trimWhiteSpaceOnBlur(elementToTrim, elementValidation) {
			elementValidation.$touch();
			this.model[elementToTrim] = this.model[elementToTrim].trim();
		},
		removeHyphen() {
			if (this.model.accountNumber.replace(/-/g, '').length == 16 && this.model.accountNumber.endsWith('-')) {
				this.model.accountNumber = this.model.accountNumber.substring(0, this.model.accountNumber.length - 1);
			}
		}
	},
	components: {
		datePicker,
		phoneInput,
		accountNumberLength,
		VueSettlementSelector,
		foreignPhoneInput,
		bankAccountNumberInputSimple,
		VueErrorMessage,
		VueInput,
		VueCheckbox,
		VueMobilephoneInput,
		VueMaskedInput
	},
	watch: {
		settlement: {
			handler(settlement) {
				if (settlement.zipCode || settlement.zipCode === '' || settlement.zipCode === 0) {
					this.model.postalCode = settlement.zipCode;
					this.model.settlement = settlement.settlement;
				}
			},
			deep: true
		}
	},
	computed: {
		...mapState('complaints', ['personalModel', 'bankAccountNumberValidations', 'loading', 'settlements']),
		...mapGetters('complaints', ['settlementList']),
		minimumDate() {
			return MIN_DATE;
		},
		maximumDate() {
			return moment().format(BACKEND_DATE_FORMAT);
		}
	},
	validations() {
		return {
			model: {
				name: {
					required,
					minLength: minLength(5),
					pattern: pattern(NAME_REGEXP)
				},
				birthDate: {
					required,
					validDate: date(BACKEND_DATE_FORMAT),
					dateLessThanOrEqual: dateLessThanOrEqual(BACKEND_DATE_FORMAT, this.maximumDate),
					dateGreaterThanOrEqual: dateGreaterThanOrEqual(BACKEND_DATE_FORMAT, this.minimumDate)
				},
				email: {
					required,
					maxLength: maxLength(100),
					email
				},
				accountNumber: this.bankAccountNumberValidations.accountMandatory
					? {
							required,
							accountNumberLength18Or24Digit
					  }
					: { accountNumberLength18Or24Digit },
				lastDigitsOfCard: this.bankAccountNumberValidations.cardNumberMandatory
					? {
							required,
							pattern: pattern(LAST_FOUR_DIGITS_REGEXP)
					  }
					: {
							pattern: pattern(LAST_FOUR_DIGITS_REGEXP)
					  },
				phoneNumber: this.model.isForeigner ? { required, pattern: pattern(FOREIGN_PHONE_REGEX) } : { required, pattern: pattern(ALL_PHONE_REGEXP) },
				country: this.model.isForeigner ? { required, maxLength: maxLength(20) } : {},
				postalCode: this.model.isForeigner ? { required, pattern: pattern(FOREIGN_ZIP_CODE_REGEXP) } : { required, pattern: pattern(ZIP_CODE_REGEXP) },
				settlement: {
					required
				},
				address: {
					required,
					minLength: minLength(5)
				}
			}
		};
	},
	mounted() {
		if (this.personalModel) {
			this.model = this.personalModel;
			this.settlement = { zipCode: this.personalModel.postalCode, settlement: this.personalModel.settlement };
			this.getSettlements(this.settlement.zipCode);
			this.$v.model.$touch();
			this.scrollToErrorMessage();
		}
	}
};
